export default __webpack_public_path__ + "static/media/eg.21fca838.svg";